export default __webpack_public_path__ + "static/media/contact.9232ba78.jpg";